import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ChargerStatusResponse } from '../../../reports/model/reports';

export type VendorChargerStatusState = {
  data: ChargerStatusResponse | null;
  loading: boolean;
  error: string | null;
  toggleValue: number;
};

const initialState: VendorChargerStatusState = {
  data: null,
  loading: false,
  error: null,
  toggleValue: 0,
};

const slice = createSlice({
  name: 'vendorChargerStatus',
  initialState,
  reducers: {
    fetchStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchSuccess: (state, action: PayloadAction<ChargerStatusResponse>) => {
      state.loading = false;
      state.data = action.payload;
      state.toggleValue = Math.floor(Math.random() * 100) + 1;
    },
    fetchFailed: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
      state.toggleValue = Math.floor(Math.random() * 100) + 1;
    },
  },
});

export const vendorChargerStatus = slice.reducer;
export const { fetchStart, fetchSuccess, fetchFailed } = slice.actions;
